import React, { JSX } from 'react';
import {
  AgxColumn,
  AgxSelect,
  AgxLabel,
  AgxRow,
  AgxBodyText,
  AgxErrorLabel,
} from '@urbanx/agx-ui-components';
import {
  dropDownNumberOptions,
  maxDropDownNumberValue,
  maxDropDownNumberLabel,
} from '../constants';

interface FilterDropDownProps {
  label: string;
  icon?: JSX.Element;
  currentValue?: string | number;
  minValue?: number;
  maxValue?: number;
  updateMinValue: (value?: number) => void;
  updateMaxValue: (value?: number) => void;
}

const FilterDropDown = ({
  label,
  icon = undefined,
  currentValue,
  minValue,
  maxValue,
  updateMinValue,
  updateMaxValue,
}: FilterDropDownProps) => {
  let errorMessage = '';

  if (minValue != null && maxValue != null) {
    if ((maxValue ?? maxDropDownNumberValue) < (minValue ?? 0)) {
      errorMessage = 'Maximum number must be higher than minimum number';
    }
  }

  const maxValueLabel =
    maxValue != null && maxValue === maxDropDownNumberValue
      ? maxDropDownNumberLabel
      : maxValue;

  return (
    <AgxColumn>
      <AgxRow fill centered>
        <AgxRow fill>
          <AgxLabel medium>{label}</AgxLabel>
        </AgxRow>
        {currentValue && (
          <AgxLabel extraClasses="neutral-grey-600" medium>
            {currentValue}
          </AgxLabel>
        )}
      </AgxRow>
      <AgxRow mediumGap centered>
        <AgxSelect
          id={`agx-select${label}DropDownMin`}
          icon={icon ? icon : undefined}
          options={dropDownNumberOptions}
          defaultValue={{ label: minValue, value: minValue }}
          onValueChanged={({ value }) =>
            updateMinValue(
              value !== undefined && value !== null && value !== ''
                ? parseFloat(value)
                : undefined
            )
          }
          dataTestId={`agx-select${label}DropDownMin`}
          hideOptionalLabel
          isMini
        />
        <AgxBodyText medium>-</AgxBodyText>
        <AgxSelect
          id={`agx-select${label}DropDownMax`}
          options={dropDownNumberOptions}
          defaultValue={{ label: maxValueLabel, value: maxValue }}
          onValueChanged={({ value }) =>
            updateMaxValue(
              value !== undefined && value !== null && value !== ''
                ? parseFloat(value)
                : undefined
            )
          }
          dataTestId={`agx-select${label}DropDownMax`}
          hideOptionalLabel
          isMini
        />
      </AgxRow>
      {errorMessage && (
        <AgxRow>
          <AgxErrorLabel error={errorMessage} />
        </AgxRow>
      )}
    </AgxColumn>
  );
};

export default FilterDropDown;
